export const DATA_GRID_PAGE_SIZE = 10

export const DATA_GRID_PAGE_SIZES = [10, 20, 50, 100]

export const RELEVANT_NUMBER_OPERATORS = {
  '=': 'equals',
  '>': 'gt',
  '<': 'lt',
  '>=': 'gte',
  '<=': 'lte'
}

export const FILTER_OPERATOR_LABELS = {
  '=': 'ist gleich',
  '>': 'ist größer als',
  '<': 'ist kleiner als',
  '>=': 'ist größer oder gleich',
  '<=': 'ist kleiner oder gleich'
}

export const NOT_HIDABLE_COLUMNS = ['action', '__check__']
